import React from "react";
import { TableCompData } from "../../../components";
import EmptyTable from "../../../components/Common/EmptyTable";
import TablePagination from "../../../components/Table/Pagination";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";

export default function LoanRepaymentTable({
  name,
  loading,
  setPageNumber,
  pagination,
  TableData,
  column,
}) {
  return (
    <>
      <main>
        <TableCompData
          marginBottom={"1rem"}
          columns={column}
          data={TableData || []}
          progressPending={loading}
          progressComponent={<TableSkeletonLoader rows={10} columns={6} />}
          message={
            !loading && (
              <EmptyTable Message={`There are currently no ${name}`} />
            )
          }
          cellPadding="12px"
        />
        {!loading && TableData?.length > 0 && pagination && (
          <TablePagination
            marginTop={"0"}
            handlePageChange={setPageNumber}
            {...pagination}
          />
        )}
      </main>
    </>
  );
}
